import React from "react";
import Sidebar from "./Sidebar";
import OpenConversation from "./OpenConversation";
import { useConversations } from "../contexts/ConversationsProvider";
import { Spinner } from "reactstrap";

export default function Dashboard({ id }) {
  const { selectedConversation } = useConversations();

  return (
    <div
      className="d-flex"
      style={{
        height: "100vh",
        backgroundColor: "#f5f7fa",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      }}
    >
      <Sidebar id={id} />
      {selectedConversation ? (
        <OpenConversation id={id} />
      ) : (
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Spinner color="light" style={{ marginBottom: "20px" }} />
            <h4 style={{ marginTop: "20px", fontWeight: 300 }}>
              Pilih percakapan untuk memulai
            </h4>
            <p style={{ marginTop: "10px", opacity: 0.8, fontSize: "14px" }}>
              Pilih dari daftar percakapan di sidebar
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
